import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSummary2TOC = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module Summary"
      videos={[
      ]}
      takeaways={[
        { text: "In this module, there are only five subtopics. You need to practice all of them." },
        { text: "Mostly, two questions will come out of these five subtopics in both CAT and FAT." },
        { text: "Sometimes, in minimization of DFA, the DFA won't get minimized. These types are also possible where you follow all the steps, but in the end, the DFA remains the same." },
      ]}
      questions={[

      ]}
      exampleVideos={[]}
    />
  );
}

export { ModuleSummary2TOC };
